import React, { useContext } from 'react';

import { Trans } from '@lingui/macro';

import PageContext from '@zego/context/PageContext';
import { BREAKPOINTS, getColWidthCalc, infoColor, unit } from '@zego/theme';
import { getCountrySupportLink } from '@zego/utils/route';

import ArrowLink from '@zego/components/ArrowLink';
import H2 from '@zego/components/atoms/H2';
import RegularText from '@zego/components/atoms/RegularText';
import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import ContentContainer from '@zego/components/ContentContainer';
import SectionDisplay from '@zego/components/SectionDisplay';
import StaticImage from '@zego/components/StaticImage';

import CustomerService1 from '@zego/static/images/CustomerService1.jpg';
import CustomerService2 from '@zego/static/images/CustomerService2.jpg';
import CustomerServiceIcon from '@zego/static/svgs/CustomerService.svg';

const CustomerService = () => {
  const { country } = useContext(PageContext);
  return (
    <SectionDisplay end>
      <ContentContainer
        css={{
          [BREAKPOINTS.medium]: {
            display: 'flex',
            flexDirection: 'row-reverse',
            justifyContent: 'space-between',
          },
        }}
      >
        <div
          css={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginBottom: unit(5),
            [BREAKPOINTS.medium]: {
              width: getColWidthCalc(12, 20, 5),
              marginBottom: 0,
            },
          }}
        >
          <View>
            <img alt="" src={CustomerServiceIcon} />
            <Spacer height={unit(2)} />
            <H2 css={{ marginBottom: unit(3) }}>
              <Trans id="Customer Service / Heading">Here to help</Trans>
            </H2>
            <RegularText css={{ marginBottom: unit(4) }}>
              {country !== 'ie' ? (
                <Trans id="Customer Service / Description">
                  Our friendly customer service team are here seven days a week
                  to answer any questions you may have. Give us a call or drop
                  us an email, we’re here to help.
                </Trans>
              ) : (
                <Trans id="Customer Service / Description / IE">
                  Our friendly customer service team are on hand to help Monday
                  to Friday with any questions you may have.
                </Trans>
              )}
            </RegularText>
            <View css={{ display: 'flex', alignItems: 'center' }}>
              <ArrowLink
                color={infoColor(5)}
                href={getCountrySupportLink(country)}
              >
                <Trans id="Customer service / Call to action">
                  Get in touch
                </Trans>
              </ArrowLink>
            </View>
          </View>
        </div>
        <div
          css={{
            overflow: 'hidden',
            width: '100%',
            [BREAKPOINTS.medium]: {
              width: getColWidthCalc(12, 20, 6),
              marginBottom: -160,
            },
          }}
        >
          <StaticImage
            alt=""
            src={CustomerService1}
            ratio={1.5}
            css={{
              display: 'block',
              width: '100%',
              position: 'relative',
              borderRadius: '4px',
              [BREAKPOINTS.medium]: {
                width: '80%',
              },
            }}
          />
          <StaticImage
            alt=""
            src={CustomerService2}
            ratio={1}
            css={{
              display: 'none',
              [BREAKPOINTS.medium]: {
                display: 'block',
                width: '50%',
                position: 'relative',
                top: -80,
                right: '-50%',
                borderRadius: '4px',
              },
            }}
          />
        </div>
      </ContentContainer>
    </SectionDisplay>
  );
};

export default CustomerService;
